import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { Injector } from "@angular/core";
import { PaymentRequiredError } from "app/exception/payment-required.error";
import { NotFoundError } from "app/exception/notfound.error";


export abstract class HttpService {

    protected http: HttpClient;

    constructor(private baseInjector: Injector) {
        this.http = this.baseInjector.get(HttpClient);
    }

    /**
     * Rest API GET
     * @param router 
     */
    protected async get<T>(router: string, params?: any): Promise<T> {

        try {
            let res = await this.http.get<T>(environment.host + environment.api_version + router, {params: params} ).toPromise();
            return res;
        } catch(ex) {
            this.errorHandler(ex);
        }
    }

    /**
     * Rest API POST
     * @param router 
     * @param body 
     */
    protected async post(router: string, body: any) {
        
        try {
            await this.http.post(environment.host + environment.api_version + router, body).toPromise();
        } catch(ex) {
            this.errorHandler(ex);
        }
    }

    /**
     * Rest API PUT
     * @param router 
     * @param body 
     */
    protected async put(router: string, body: any) {
        
        try {
            await this.http.put(environment.host + environment.api_version + router, body).toPromise();
        } catch(ex) {
            this.errorHandler(ex);
        }
    }


    /**
     * エラーが発生した時、エラーメッセージを取得する
     * @param ex 
     */
    private errorHandler(ex) {

        console.error(ex);
        
        let errerMessage: string;

        if (ex.status) {

            switch(ex.status) {
                
                case 400:
                case 401:
                case 403:
                    if (ex.error && ex.error.message) {
                        throw new Error(ex.error.message);
                    }
                    break;


                case 402:
                    if (ex.error && ex.error.message) {
                        throw new PaymentRequiredError(ex.error.message);
                    }
                    break;
                
                case 404:
                    if (ex.error && ex.error.message) {
                        throw new NotFoundError(ex.error.message);
                    }
                    break;
                

                case 500:
                    throw new Error('サーバエラーが発生しました。管理者に連絡してください');

                default:
                    throw new Error('予想外エラーが発生しました。管理者に連絡してください');

            }
        }


        
    }
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/services/base/http.service.ts